import type { MaintenanceManualsDocument } from "../types";
import { createDateColumn, createStringColumn } from "./columnHelpers";
import { createLinkColumn } from "./linkColumnHelper";

const namespace = "maintenance_manuals";

export const maintenanceManualsColumns = [
    createStringColumn<MaintenanceManualsDocument>({
        namespace,
        field: "metadata.document_number",
        header: "Document Number",
    }),
    createStringColumn<MaintenanceManualsDocument>({
        namespace,
        field: "metadata.title",
        header: "Title",
        overrides: { size: 300 },
    }),
    createStringColumn<MaintenanceManualsDocument>({
        namespace,
        field: "metadata.applicability",
        header: "Applicability",
    }),
    createStringColumn<MaintenanceManualsDocument>({
        namespace,
        field: "metadata.content_type",
        header: "Content Type",
    }),
    createStringColumn<MaintenanceManualsDocument>({
        namespace,
        field: "metadata.distribution",
        header: "Distribution",
    }),
    createStringColumn<MaintenanceManualsDocument>({
        namespace,
        field: "metadata.export_control",
        header: "Export Control",
        accessor: (row) => row.fields?.export_control ?? "N/A",
    }),
    createStringColumn<MaintenanceManualsDocument>({
        namespace,
        field: "metadata.ip_control",
        header: "IP Control",
        accessor: (row) => row.fields?.ip_control ?? "N/A",
    }),
    createLinkColumn<MaintenanceManualsDocument>({
        namespace,
        field: "metadata.source",
        header: "Source",
    }),
    createDateColumn<MaintenanceManualsDocument>({
        namespace,
        field: "metadata.date",
        header: "Date Of Issue",
        accessor: (originalRow) => {
            const dateValue = originalRow._source?.metadata?.date
                ? new Date(originalRow._source.metadata.date * 1000)
                : new Date("2000-01-01T00:00:00.000Z");
            if (dateValue) {
                dateValue.setHours(0, 0, 0, 0);
            }
            return dateValue;
        },
    }),
];
